import { Action, createReducer, on } from '@ngrx/store';
import { EmployeeTransitionDetail, EmployeeTransitionLookups, EmployeeTransitionRow } from 'src/app/models/credentialTransitionManagement';
import { PagingResultsModel } from 'src/app/models/pagingResultsModel';
import * as actions from './credential-transitions.actions';

export interface CredentialTransitionsState
{
  list: PagingResultsModel<EmployeeTransitionRow>;
  lookups: EmployeeTransitionLookups;
  detail: EmployeeTransitionDetail;
  selectedID: number;
  loadingList: boolean;
  loadingDetail: boolean;
  saving: boolean;
  error: string;
  notice: string;
}

const initialState: CredentialTransitionsState =
{
  list: null,
  lookups: { campuses: [], processes: [] },
  detail: null,
  selectedID: null,
  loadingList: false,
  loadingDetail: false,
  saving: false,
  error: '',
  notice: ''
};

const reducer = createReducer(initialState,
  on(actions.clearEmployeeTransitions, () => initialState),
  on(actions.loadEmployeeTransitions, state => ({
    ...state,
    loadingList: true,
    error: ''
  })),
  on(actions.loadEmployeeTransitionsSuccess, (state, { list }) => ({
    ...state,
    list,
    loadingList: false
  })),
  on(actions.loadEmployeeTransitionLookupsSuccess, (state, { lookups }) => ({
    ...state,
    lookups
  })),
  on(actions.loadEmployeeTransition, (state, { id }) => ({
    ...state,
    selectedID: id,
    detail: null,
    loadingDetail: true,
    error: '',
    notice: ''
  })),
  on(actions.loadEmployeeTransitionSuccess, (state, { detail }) => state.selectedID === detail.id
    ? { ...state, detail, loadingDetail: false }
    : state),
  on(actions.closeEmployeeTransition, state => ({
    ...state,
    selectedID: null,
    detail: null,
    loadingDetail: false,
    notice: '',
    error: ''
  })),
  on(actions.updateEmployeeTransition, actions.advanceEmployeeTransition, state => ({
    ...state,
    saving: true,
    error: '',
    notice: ''
  })),
  on(actions.employeeTransitionSaved, (state, { detail, notice }) => ({
    ...state,
    saving: false,
    detail: state.selectedID === detail.id ? detail : state.detail,
    notice
  })),
  on(actions.employeeTransitionFailed, (state, { error }) => ({
    ...state,
    loadingList: false,
    loadingDetail: false,
    saving: false,
    error
  }))
);

export function credentialTransitionsReducer(state: CredentialTransitionsState | undefined, action: Action)
{
  return reducer(state, action);
}
